import { Util } from '../rocket';

import { MouseSensor } from './mouse-sensor';

import { TouchSensor } from './touch-sensor';

import { SensorHub } from './sensor-hub';

import {
  DragEventManagerConfig,
  DRAG_EVENT_MANAGER_DEFAULT_CONFIG,
} from './drag-event-manager-config';

export class DragEventManager {
  public config: DragEventManagerConfig;

  public mouseSensor: MouseSensor;
  public touchSensor: TouchSensor;
  public sensorHub: SensorHub;

  public isActive: boolean = false;

  public isListeningToScroll: boolean = false;
  public scrollDebounce?: Function;
  public isScrolling: boolean = false;

  constructor(config?: Partial<DragEventManagerConfig>) {
    this.config = Object.assign({}, DRAG_EVENT_MANAGER_DEFAULT_CONFIG);
    this.setConfig(config);
    this.mouseSensor = new MouseSensor(this);
    this.touchSensor = new TouchSensor(this);
    this.sensorHub = new SensorHub(this);
  }

  public setConfig(config?: Partial<DragEventManagerConfig>): this {
    if (typeof config === 'object') Object.assign(this.config, config);
    return this;
  }

  public initialize(): this {
    this.stopListenToScroll();
    this.mouseSensor.stop();
    this.touchSensor.stop();

    this.listenToScroll();
    this.mouseSensor.listen();
    this.touchSensor.listen();
    return this;
  }

  private eventHandlerScroll = () => (this.isScrolling = true);

  private eventHandlerScrollEnd = () => (this.isScrolling = false);

  public listenToScroll() {
    if (this.isListeningToScroll === false) {
      this.scrollDebounce = Util.debounce(
        this.config.scrollEndDebounceDelay,
        this.eventHandlerScrollEnd,
      );
      document.body.addEventListener('touchmove', this.eventHandlerScroll);
      document.body.addEventListener('touchmove', this.scrollDebounce as EventListener);
      window.addEventListener('scroll', this.eventHandlerScroll);
      window.addEventListener('scroll', this.scrollDebounce as EventListener);
      this.isListeningToScroll = true;
    }
  }

  public stopListenToScroll() {
    if (this.isListeningToScroll === true) {
      document.body.addEventListener('touchmove', this.eventHandlerScroll);
      document.body.addEventListener('touchmove', this.eventHandlerScrollEnd as EventListener);
      window.removeEventListener('scroll', this.eventHandlerScroll);
      window.removeEventListener('scroll', this.eventHandlerScrollEnd as EventListener);
      this.isListeningToScroll = false;
    }
  }
}
